import React from 'react'
import StyledSubHeader from '@/components/pages/NewDatasetJobPage/StyledSubHeader'
import NewJobBooleanFilters from '@/components/pages/NewDatasetJobPage/NewJobBooleanFilters'
import NewJobNumberFilters from '@/components/pages/NewDatasetJobPage/NewJobNumberFilters'
import NewJobStringFilters from '@/components/pages/NewDatasetJobPage/NewJobStringFilters'
import Grid from '@mui/material/GridLegacy'
import styled from 'styled-components'


import {DatasetFilterOptions} from '@/components/pages/NewDatasetJobPage/types'
import Typography from '@mui/material/Typography'

const StyledGridItem = styled(Grid)`
    padding-top: 0 !important;
`

type DatasetFilterSectionProps = {
    filterSectionHeader: string;
    filterOptions?: any;
    selectedFilters: DatasetFilterOptions;
    onBoolFilterSelect: (filterName: string, checked: boolean, filterVal: boolean) => void;
    onNumFilterSelect: (filterName: string, checked: boolean, filterVal: any) => void;
    onStringFilterSelect: (filterName: string, checked: boolean, filterVal: any) => void;
    filtersLoading: boolean;
    filtersError: boolean;
}

const DatasetFilterSection = ({
    filterSectionHeader,
    filterOptions,
    selectedFilters,
    onBoolFilterSelect,
    onNumFilterSelect,
    onStringFilterSelect,
    filtersLoading,
    filtersError
}: DatasetFilterSectionProps) => {
    return (
        <Grid container spacing={1} paddingTop={1} marginBottom={2}
            border="1px solid"
            borderRadius="4px"
            borderColor="lightgray">
            <StyledGridItem item xs={12}>
                <Typography variant="h5" paddingBottom={2}>{filterSectionHeader}</Typography>
            </StyledGridItem>
            <StyledGridItem item xs={4}>
                <StyledSubHeader>Bool filters</StyledSubHeader>
                <NewJobBooleanFilters
                    boolFilters={filterOptions?.bool_filters}
                    selectedFilters={selectedFilters.boolFilters}
                    onFilterSelect={onBoolFilterSelect}
                    isLoading={filtersLoading}
                    error={filtersError}
                />
            </StyledGridItem>
            <StyledGridItem item xs={8}>
                <StyledSubHeader>Num filters</StyledSubHeader>
                <NewJobNumberFilters
                    numberFilters={filterOptions?.num_filters}
                    selectedFilters={selectedFilters.numFilters}
                    onFilterSelect={onNumFilterSelect}
                    isLoading={filtersLoading}
                    error={filtersError}
                />
            </StyledGridItem>
            <StyledGridItem item xs={12}>
                <StyledSubHeader>String filters</StyledSubHeader>
                <NewJobStringFilters
                    stringFilters={filterOptions?.string_filters}
                    selectedFilters={selectedFilters.stringFilters}
                    onFilterSelect={onStringFilterSelect}
                    isLoading={filtersLoading}
                    error={filtersError}
                />
            </StyledGridItem>
        </Grid>
    )
}

export default DatasetFilterSection